var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1SocketTvFm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 69h62V7H7v62zm4-58h54v54H11V11zm48.37 25.5H55.3a6 6 0 00-4.3-4.3v-4.08a10 10 0 018.37 8.38zm-4.07 3h4.07A10 10 0 0151 47.88V43.8a6 6 0 004.3-4.3zM49.5 41a3 3 0 110-5.999 3 3 0 010 5.999zM48 43.8v4.08A10 10 0 0139.7 40h4.15A6 6 0 0048 43.8zM43.59 37h-4A10 10 0 0148 28.12v4.08a6 6 0 00-4.41 4.8zm-18.53-9a10 10 0 100 20 10 10 0 000-20zm0 16a6 6 0 110-12 6 6 0 010 12zm3-6a3 3 0 11-5.999 0 3 3 0 015.999 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_TV_FM.db2050ea.svg";
export { SvgA1SocketTvFm as ReactComponent };